const nameof = <T>(name: keyof T) => name;
export default nameof;
